import { html, type TemplateResult } from "lit";
import { property, query } from "lit/decorators.js";
import { UiElement } from "@zebrabi/ui-components";
import styles from "./field-bucket.styles";

/** A labelled drop zone; the fields it holds are slotted in by the pane. As a list it has no frame: the Fields list */
export class FieldsPaneBucket extends UiElement {
    static styles = styles;

    @property({ type: String })
    public label = "";

    /** Draws the zone as a plain list without the dashed frame */
    @property({ type: Boolean, reflect: true })
    public list = false;

    /** The dragged field may be dropped here: a blue dashed frame while the drag lasts */
    @property({ type: Boolean, reflect: true, attribute: "drop-target" })
    public dropTarget = false;

    /** The pointer is over this drop target: the frame turns solid and the fill darker */
    @property({ type: Boolean, reflect: true, attribute: "drop-active" })
    public dropActive = false;

    /** The dragged field cannot land here: the bucket fades back while the drag lasts */
    @property({ type: Boolean, reflect: true })
    public faded = false;

    @query(".zone")
    private readonly zone?: HTMLElement;

    /** The drop zone's box on screen, for the pane's hit-testing */
    public zoneRect(): DOMRect {
        return (this.zone ?? this).getBoundingClientRect();
    }

    protected render(): TemplateResult {
        return html`
            <p>${this.label}</p>
            <div class="zone" part="zone"><slot></slot></div>
        `;
    }
}
